import React, {useEffect, useRef, useState} from "react";
import {useSelector} from "../../../shared-services/redux-tiny";
import currentTheme from "../../../react-themes/theme";
import useClickOutside from "../../shared/useClickOutside";
import topLayerState from "../../../shared-services/globalState/topLayerState";
import {useLocation} from "react-router-dom";

const theme = currentTheme();

const BottomNotification = (props) => {
  const {
    name,
    closeOnClickOutside = true,
    closeOnLeave = true,
    children,
    className = "",
    style
  } = props;

  const hiddenHeight = -10;

  const [visible, setVisible] = useState(false);
  const [height, setHeight] = useState(hiddenHeight);

  const {bottomNotification} = useSelector(state => state.topLayer);
  const {emptyBottomNotification} = topLayerState();

  const location = useLocation();

  const ref = useRef();
  const timeout = theme.transitionTime.medium;

  closeOnClickOutside && useClickOutside(
    ".bottom-notification",
    () => emptyBottomNotification(),
    [visible]
  );

  const calculateHeight = () => {
    setHeight(ref.current?.clientHeight);
  };

  const toggle = (state) => {
    if (!visible && !state) return;

    if (state) {
      setVisible(true);
    } else {
      setHeight(hiddenHeight);
      setTimeout(() => {
        setVisible(false);
      }, timeout);
    }
  };

  useEffect(() => {
    if (bottomNotification?.name === name) {
      toggle(true);
    } else toggle(false);
  }, [bottomNotification]);

  useEffect(() => {
    if (visible) {
      requestAnimationFrame(() => setTimeout(() => {
        calculateHeight();
      }));
    }
  }, [visible]);

  useEffect(() => {
    if (closeOnLeave) emptyBottomNotification();
  }, [location]);

  return <>
    <div
      ref={ref}
      className={`
        bottom-notification
        position-absolute
        full-width
        ${className}
        `}
      style={{
        transition: `top ${timeout}ms`,
        top: `${-height}px`,
        zIndex: "-1",
        ...style
      }}
    >
      {children}
    </div>
  </>;
};

export default BottomNotification;
